// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"128":"88bf9b23","617":"4397d048"}[chunkId] + ".js";
};